import { render, staticRenderFns } from "./InitDossierProgress.vue?vue&type=template&id=0525a09e&scoped=true"
import script from "./InitDossierProgress.vue?vue&type=script&lang=ts"
export * from "./InitDossierProgress.vue?vue&type=script&lang=ts"
import style0 from "./InitDossierProgress.vue?vue&type=style&index=0&id=0525a09e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0525a09e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0525a09e')) {
      api.createRecord('0525a09e', component.options)
    } else {
      api.reload('0525a09e', component.options)
    }
    module.hot.accept("./InitDossierProgress.vue?vue&type=template&id=0525a09e&scoped=true", function () {
      api.rerender('0525a09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InitDossierProgress.vue"
export default component.exports